import {listUserProfilesFragment} from './fragments'

export const listStrikes = /* GraphQL */ `
  query ListStrikes($underlying: String!, $expirationOptionTypeStrike: ModelOptionPrimaryCompositeKeyConditionInput) {
    listOptions(underlying: $underlying, expirationOptionTypeStrike: $expirationOptionTypeStrike) {
      items {
        expirationStyle
        tradingHours
        strike
      }
    }
  }
`;

export const getUserProfileDueDiligence = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      id
      contactDetails {
        givenName
        familyName
        phone {
          phoneType
          phoneNumber
          __typename
        }
        email
        __typename
      }
      homeAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      mailingAddress {
        streets
        city
        state
        postal
        country
        __typename
      }
      entityAccountInformation {
        entityName
        entityTaxId
        stateOfOrigin
        mailingPreference
        isPabAccount
        issuerDirectCommunicationCode
        isExemptLegalCustomer
        exemption
        legalEntityIdentifier
        entityOfficers {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
          }
          socialSecurityNumber
          identificationNumber
        }
        beneficialOwners {
          familyName
          givenName
          dateOfBirth
          address {
            streets
            city
            state
            postal
            country
          }
          socialSecurityNumber
          identificationNumber
        }
      }
      createdAt
      updatedAt
      citizenshipCountry
      investmentProfile {
          riskStandardOptions
          uncoveredOptionWriters
          investmentExperience
          riskTolerance
          investmentObjective
          minTotalNetWorthUSD
          minAnnualIncomeUSD
          minLiquidNetWorthUSD
          maxTotalNetWorthUSD
          maxAnnualIncomeUSD
          maxLiquidNetWorthUSD
          timeHorizon
          liquidityNeeds
          stockTradesPerYear
          optionsTradesPerYear
          commonditiesTradesPerYear
          corporateBondsTradesPerYear
          municipalBondsTradesPerYear
          governmentBondsTradesPerYear
          fundsTradesPerYear
          marginAccountTradesPerYear
        }
      __typename
    }
  }
`;

export const positionHistoryByAccountNumber =`
  query positionHistoryByAccountNumber (
    $accountNumber: String!
    $filter: ModelPositionHistoryFilterInput
    $nextToken: String
    ) {
      positionHistoryByAccountNumber (
        accountNumber: $accountNumber
        filter: $filter
        nextToken: $nextToken
      ) {
        items {
          accountNumber
          quantity
          cost
          netProceed
          realizedGainLoss
          description1
          taxLotCloseSellDate
          taxLotOpenBuyDate
          settlementDate
          openBuyPrice
          securityType
          symbolMsd
        }
        nextToken
      }
    }
  `;

export const checkAccountInformations = /* GraphQL */ `
  query ListAccountInformations(
    $accountNumber: String
    $filter: ModelAccountInformationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAccountInformations(
      accountNumber: $accountNumber
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        accountNumber
        approvalStatus
      }  
    }
  }
`;
export const userFormByAccountNumber = /* GraphQL */ `
  query FormByAccountNumber(
    $accountNumber: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFormFilterInput
    $limit: Int
    $nextToken: String
  ) {
    formByAccountNumber(
      accountNumber: $accountNumber
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        # riskStandardOptions
        # uncoveredOptionWriters
        # investmentExperience
        # riskTolerance
        # investmentObjective
        # minTotalNetWorthUSD
        # minAnnualIncomeUSD
        # minLiquidNetWorthUSD
        # maxTotalNetWorthUSD
        # maxAnnualIncomeUSD
        # maxLiquidNetWorthUSD
        marginRequested
        requestedOptionLevels
        approvedOptionLevels
        terms
        # stockTradesPerYear
        # optionsTradesPerYear
        # commonditiesTradesPerYear
        # corporateBondsTradesPerYear
        # municipalBondsTradesPerYear
        # governmentBondsTradesPerYear
        # fundsTradesPerYear
        # marginAccountTradesPerYear
        # timeHorizon
        # liquidityNeeds
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const userOrderByAccountNumber = /* GraphQL */ `
  query UserOrderByAccountNumber(
    $accountNumber: String!
    $symbol: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $executionReportsFilter: ModelExecutionReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderByAccountNumber(
      accountNumber: $accountNumber
      symbol: $symbol
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        brokerOverride
        brokerId
        owner
        symbol
        quantity
        avgPx
        originalOrderId
        cancel
        commission
        cancelReplace
        limitPrice
        stopPrice
        stockValue
        strategy
        orderType
        timeInForce
        instruction
        cashSecured
        cashSecuredAmount
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
        }
        message
        submitStatus
        status
        executionReports(filter: $executionReportsFilter) {
          items {
            id
            owner
            accountInformationId
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            uploadedToBackoffice
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            createdAt
            updatedAt
            userOrderExecutionReportsId
          }
          nextToken
        }
        createdAt
        updatedAt
        accountInformationUserOrdersId
      }
      nextToken
    }
  }
`;
export const listAchRelationships = /* GraphQL */ `
  query ListAchRelationships(
    $id: ID
    $filter: ModelAchRelationshipFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAchRelationships(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        achRelationshipStatic {
          id
          accountNumber
          owner
          bankRoutingNumber
          bankAccount
          bankAccountOwnerName
          bankAccountType
          deleted
          approvalMethod
          relationshipId
          status
          statusCode
          statusJson
          createdAt
          updatedAt
        }
        deleted
        nickname
        microDepositTries
        microDeposits
        microDepositStatus
        depositWithdrawalRequests {
          items {
            id
            accountNumber
            owner
            relationshipId
            amount
            message
            memo
            reason
            transferId
            deposit
            status
            cancel
            createdAt
            updatedAt
            achRelationshipDepositWithdrawalRequestsId
          }
          nextToken
        }
        reissueTries
        reissue
        createdAt
        updatedAt
        achRelationshipAchRelationshipStaticId
        achRelationshipAccountInformationId
      }
      nextToken
    }
  }
`;
export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles(
    $id: ID
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserProfiles(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        ${listUserProfilesFragment}
      }
      nextToken
    }
  }
`;
export const userProfileByOwner = /* GraphQL */ `
  query UserProfileByOwner(
    $owner: String!
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    userProfileByOwner(
      owner: $owner
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        ${listUserProfilesFragment}
      }
      nextToken
    }
  }
`;
export const listUserProfilesForDueDiligence = /* GraphQL */ `
  query listUserProfiles(
    $id: ID
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserProfiles(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        owner
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
          }
          email
        }
        homeAddress {
          streets
          city
          state
          postal
          country
        }
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
          }
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
        }
        entityAccountInformation {
          entityName
          entityTaxId
          stateOfOrigin
          mailingPreference
          isPabAccount
          issuerDirectCommunicationCode
          isExemptLegalCustomer
          exemption
          legalEntityIdentifier
          entityOfficers {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
            }
            socialSecurityNumber
            identificationNumber
          }
          beneficialOwners {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
            }
            socialSecurityNumber
            identificationNumber
          }
        }
        trustedContact {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
            }
            email
          }
          address {
            streets
            city
            state
            postal
            country
          }
        }
        investmentProfile {
          riskStandardOptions
          uncoveredOptionWriters
          investmentExperience
          riskTolerance
          investmentObjective
          minTotalNetWorthUSD
          minAnnualIncomeUSD
          minLiquidNetWorthUSD
          maxTotalNetWorthUSD
          maxAnnualIncomeUSD
          maxLiquidNetWorthUSD
          timeHorizon
          liquidityNeeds
          stockTradesPerYear
          optionsTradesPerYear
          commonditiesTradesPerYear
          corporateBondsTradesPerYear
          municipalBondsTradesPerYear
          governmentBondsTradesPerYear
          fundsTradesPerYear
          marginAccountTradesPerYear
        }
        dateOfBirth
        socialSecurityNumber
        citizenshipCountry
        catAccountholderType
        customerType
        accountType
        politicallyExposed {
          politicalOrganization
          immediateFamily
        }
        controlPersonSymbols
        affiliated {
          firmName
          affiliatedApproval
          docS3Key
        }
        customerAccountAgreement
        privacyPolicy
        accountNumbers
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listStocks = /* GraphQL */ `
  query ListStocks(
    $id: ID
    $symbol: ModelStringKeyConditionInput
    $filter: ModelStockFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listStocks(
      id: $id
      symbol: $symbol
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        symbol
        description
        autocompleteWeight
      }
      nextToken
    }
  }
`;
export const listForms = /* GraphQL */ `
  query ListForms(
    $id: ID
    $filter: ModelFormFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listForms(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const accountInformationByAccountRequestStatus = /* GraphQL */ `
  query AccountInformationByAccountRequestStatus(
    $accountRequestStatus: String!
    $accountNumberAccountName: ModelAccountInformationByAccountRequestStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccountInformationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountInformationByAccountRequestStatus(
      accountRequestStatus: $accountRequestStatus
      accountNumberAccountName: $accountNumberAccountName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexJson
        accountStatus
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
      }
      nextToken
    }
  }
`;
export const listGroupOrders = /* GraphQL */ `
  query ListGroupOrders(
    $id: ID
    $filter: ModelGroupOrderFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listGroupOrders(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        allocation {
          subAccountNumber
          accountNumber
          allocation
          filledAllocation
          account_information_id
          user_profile_id
          balance_id
          sub_account_balance_id
          position_ids
          individualOrderStatus
        }
        portfolio
        newsLetter
        owner
        subAccountNumbers
        cancel
        cancelReplace
        commission
        symbol
        side
        quantity
        limitPrice
        stopPrice
        stockValue
        originalGroupOrderId
        originalOrderId
        strategy
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          bid
          ask
          sharesPerContract
        }
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getStockLookup = /* GraphQL */ `
  query GetStockLookup($type: String!) {
    getStockLookup(type: $type) {
      symbol
      description
      autocompleteWeight
    }
  }
`;

export const searchUserProfilesByEmail = `
  query searchUserProfilesByEmail($email: String!) {
    searchUserProfilesByEmail(email: $email) {
      ${listUserProfilesFragment}
    }
  }
`;

export const searchUserProfilesByFamilyName = `
  query searchUserProfilesByFamilyName($familyName: String!) {
    searchUserProfilesByFamilyName(familyName: $familyName) {
      ${listUserProfilesFragment}
    }
  }
`;

export const getBalance = `
  query GetBalance($id: ID!) {
    getBalance(id: $id) {
      id
      accountNumber
      accountType
      owner
      overnightBuyingPowerID
      firm
      totalEquity
      marginEquity
      marginRequirement
      marginExcessEquity
      cashEquity
      cashRequirement
      cashExcessEquity
      overnightBuyingPowerIssued
      dayTradeBuyingPowerIssued
      regTBuyingPowerIssued
      overnightFactorIssued
      dayTradeFactorIssued
      marginEquityPercent
      positionMarketValue
      longEquityMarketValue
      shortEquityMarketValue
      longOptionMarketValue
      shortOptionMarketValue
      totalTradeBalance
      totalSettleBalance
      cashTradeBalance
      marginTradeBalance
      shortTradeBalance
      cashSettleBalance
      marginSettleBalance
      shortSettleBalance
      moneyMarketSettleBalance
      moneyMarketTradeBalance
      marginExcessEquitySod
      cashExcessEquitySod
      netBalanceSod
      freeCash
      sma
      availableToWithdraw
      optionsRequirement
      nonOptionsRequirement
      lastUpdate
      nonOptionsRequirementNotConcentrated
      typeIUnavailableCashProceeds
      typeIIUnavailableCashProceeds
      netBalance
      smaCommitted
      netLiquidity
      pendingDebitInterest
      pendingDebitDividends
      fullyPaidUnsettledFunds
      cashOnOrders
      buyingPowerOnOrders
      updateFlag
      createdAt
      updatedAt
    }
  }
`;

export const listBalances = `
  query ListBalances(
    $filter: ModelBalanceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
      listBalances(
        filter: $filter
        limit: $limit
        nextToken: $nextToken
        sortDirection: $sortDirection
      ) {
        items {
          id
          accountNumber
          accountType
          owner
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          updateFlag
          createdAt
          updatedAt
        }
        nextToken
      }
    }
`;

export const userPermissionsByAccountNumber = /* GraphQL */ `
  query UserPermissionsByAccountNumber(
    $accountNumber: String!
    $systemAccess: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserPermissionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userPermissionsByAccountNumber(
      accountNumber: $accountNumber
      systemAccess: $systemAccess
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        systemAccess
        equityTrading
        optionsTrading
        cryptoTrading
        margin
        securitiesLending
        optionsLevel
        exitOnlyTrades
        restrictReason
        allowCancelOrder
        allowModifyOrder
        achWithdrawal
        patternDayTrader
        achApproval
        profileStatus
        betaFeatures
        createdAt
        updatedAt
        userPermissionsAccountInformationId
        achDeposit
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const achDepositWithdrawalRequestByAccountNumber = /* GraphQL */ `
  query AchDepositWithdrawalRequestByAccountNumber(
    $accountNumber: String!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAchDepositWithdrawalRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    achDepositWithdrawalRequestByAccountNumber(
      accountNumber: $accountNumber
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        relationshipId
        amount
        message
        memo
        reason
        iraContributionDistribution {
          contributionType
          applyToPriorYear
          distributionReason
          federalTaxWithholding {
            valueType
            value
          }
          stateTaxWithholding {
            valueType
            value
          }
        }
        isFullDisbursement
        transferId
        deposit
        status
        cancel
        createdAt
        updatedAt
        achRelationshipDepositWithdrawalRequestsId
      }
      nextToken
    }
  }
`;

export const listAccountInformations = /* GraphQL */ `
  query ListAccountInformations(
    $id: ID
    $filter: ModelAccountInformationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAccountInformations(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        owner
        accountNumber
        accountName
        accountType
        customerType
        accountRequestStatus
        investigationStatus
        apexId
        apexJson
        accountStatus
        balance {
          id
          accountNumber
          owner
          overnightBuyingPowerID
          firm
          totalEquity
          marginEquity
          marginRequirement
          marginExcessEquity
          cashEquity
          cashRequirement
          cashExcessEquity
          overnightBuyingPowerIssued
          dayTradeBuyingPowerIssued
          regTBuyingPowerIssued
          overnightFactorIssued
          dayTradeFactorIssued
          marginEquityPercent
          positionMarketValue
          longEquityMarketValue
          shortEquityMarketValue
          longOptionMarketValue
          shortOptionMarketValue
          totalTradeBalance
          totalSettleBalance
          cashTradeBalance
          marginTradeBalance
          shortTradeBalance
          cashSettleBalance
          marginSettleBalance
          shortSettleBalance
          moneyMarketSettleBalance
          moneyMarketTradeBalance
          freeCash
          sma
          availableToWithdraw
          optionsRequirement
          nonOptionsRequirement
          lastUpdate
          nonOptionsRequirementNotConcentrated
          typeIUnavailableCashProceeds
          typeIIUnavailableCashProceeds
          netBalance
          smaCommitted
          netLiquidity
          pendingDebitInterest
          pendingDebitDividends
          fullyPaidUnsettledFunds
          cashOnOrders
          buyingPowerOnOrders
          marginExcessEquitySod
          cashExcessEquitySod
          netBalanceSod
          optionBuyingPowerInternal
          stockBuyingPowerInternal
          updateFlag
          accountType
          pendingTransfers {
            deposit
            amount
            achDepositWithdrawalRequestId
            __typename
          }
          createdAt
          updatedAt
          balanceAccountInformationId
          __typename
        }
        permissions {
          id
          accountNumber
          owner
          systemAccess
          equityTrading
          optionsTrading
          cryptoTrading
          margin
          securitiesLending
          optionsLevel
          exitOnlyTrades
          restrictReason
          allowCancelOrder
          allowModifyOrder
          achWithdrawal
          patternDayTrader
          achApproval
          profileStatus
          betaFeatures
          achDeposit
          createdAt
          updatedAt
          userPermissionsAccountInformationId
          __typename
        }
        subAccounts {
          items {
            id
            accountNumber
            owner
            subAccountName
            subAccountNumber
            selfDirected
            balance {
              id
              accountNumber
              owner
              subAccountName
              subAccountNumber
              overnightBuyingPowerID
              firm
              totalEquity
              marginEquity
              marginRequirement
              marginExcessEquity
              cashEquity
              cashRequirement
              cashExcessEquity
              overnightBuyingPowerIssued
              dayTradeBuyingPowerIssued
              regTBuyingPowerIssued
              overnightFactorIssued
              dayTradeFactorIssued
              marginEquityPercent
              positionMarketValue
              longEquityMarketValue
              shortEquityMarketValue
              longOptionMarketValue
              shortOptionMarketValue
              totalTradeBalance
              totalSettleBalance
              cashTradeBalance
              marginTradeBalance
              shortTradeBalance
              cashSettleBalance
              marginSettleBalance
              shortSettleBalance
              moneyMarketSettleBalance
              moneyMarketTradeBalance
              freeCash
              sma
              availableToWithdraw
              optionsRequirement
              nonOptionsRequirement
              lastUpdate
              nonOptionsRequirementNotConcentrated
              typeIUnavailableCashProceeds
              typeIIUnavailableCashProceeds
              netBalance
              smaCommitted
              netLiquidity
              pendingDebitInterest
              pendingDebitDividends
              fullyPaidUnsettledFunds
              cashOnOrders
              buyingPowerOnOrders
              marginExcessEquitySod
              cashExcessEquitySod
              netBalanceSod
              optionBuyingPowerInternal
              stockBuyingPowerInternal
              accountType
              createdAt
              updatedAt
              __typename
            }
            transfers {
              items {
                id
                accountNumber
                owner
                subAccountNumber
                toSubAccountNumber
                amount
                message
                deposit
                status
                cancel
                createdAt
                updatedAt
                subAccountTransfersId
                __typename
              }
              nextToken
              __typename
            }
            commissionCode
            repCode
            newsLetter {
              newsLetter
              portfolio
              __typename
            }
            stock {
              stockSignals
              maxDollarAllocationPerSignal
              maxNumberOfSharesPerSignal
              allOrNone
              roundLotsOnly
              multiplier
              __typename
            }
            option {
              optionSignals
              maxDollarAllocationPerSignal
              maxNumberOfContractsPerSignal
              allOrNone
              multiplier
              __typename
            }
            createdAt
            updatedAt
            accountInformationSubAccountsId
            subAccountBalanceId
            __typename
          }
          nextToken
          __typename
        }
        documentUpload {
          items {
            id
            accountNumber
            owner
            investigationId
            investigationNote
            submittedBy
            document {
              documentTag
              documentType
              s3uri
              __typename
            }
            approvedBy
            approvalStatus
            createdAt
            updatedAt
            accountInformationDocumentUploadId
            __typename
          }
          nextToken
          __typename
        }
        selectedWatchlist {
          items {
            id
            accountNumber
            owner
            watchListName
            selectedStocks
            createdAt
            updatedAt
            accountInformationSelectedWatchlistId
            __typename
          }
          nextToken
          __typename
        }
        achRelationship {
          id
          accountNumber
          owner
          achRelationshipStatic {
            id
            accountNumber
            owner
            plaidProcessorToken
            plaidAccountId
            bankRoutingNumber
            bankAccount
            bankAccountOwnerName
            bankAccountType
            deleted
            approvalMethod
            relationshipId
            status
            statusCode
            statusJson
            createdAt
            updatedAt
            __typename
          }
          deleted
          nickname
          microDepositTries
          microDeposits
          microDepositStatus
          depositWithdrawalRequests {
            items {
              id
              accountNumber
              owner
              relationshipId
              amount
              message
              memo
              reason
              iraContributionDistribution {
                contributionType
                applyToPriorYear
                distributionReason
                federalTaxWithholding {
                  valueType
                  value
                  __typename
                }
                stateTaxWithholding {
                  valueType
                  value
                  __typename
                }
                __typename
              }
              isFullDisbursement
              transferId
              deposit
              status
              cancel
              createdAt
              updatedAt
              achRelationshipDepositWithdrawalRequestsId
              __typename
            }
            nextToken
            __typename
          }
          reissueTries
          reissue
          createdAt
          updatedAt
          achRelationshipAchRelationshipStaticId
          achRelationshipAccountInformationId
          __typename
        }
        userProfileIds
        createdAt
        updatedAt
        userProfileAccountsId
        draftUserProfileAccountsId
        accountInformationBalanceId
        accountInformationPermissionsId
        accountInformationAchRelationshipId
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listDocumentUploads = /* GraphQL */ `
  query ListDocumentUploads(
    $id: ID
    $filter: ModelDocumentUploadFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDocumentUploads(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        accountNumber
        owner
        investigationId
        investigationNote
        submittedBy
        document {
          documentTag
          documentType
          s3uri
          __typename
        }
        approvedBy
        approvalStatus
        createdAt
        updatedAt
        accountInformationDocumentUploadId
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getInvestmentProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      investmentProfile {
        riskStandardOptions
        uncoveredOptionWriters
        investmentExperience
        riskTolerance
        investmentObjective
        minTotalNetWorthUSD
        minAnnualIncomeUSD
        minLiquidNetWorthUSD
        maxTotalNetWorthUSD
        maxAnnualIncomeUSD
        maxLiquidNetWorthUSD
        timeHorizon
        liquidityNeeds
        stockTradesPerYear
        optionsTradesPerYear
        commonditiesTradesPerYear
        corporateBondsTradesPerYear
        municipalBondsTradesPerYear
        governmentBondsTradesPerYear
        fundsTradesPerYear
        marginAccountTradesPerYear
        optionDisclosureDeliveryDate
        priorInvestmentExperiences {
          firmName
          numberOfYears
          stillOpen
          estimatedValueUSD
          __typename
        }
        __typename
      }
    }
  }
`;

export const userOrderByAccountNumberAndCreatedAt = /* GraphQL */ `
  query UserOrderByAccountNumberAndCreatedAt(
    $accountNumber: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderByAccountNumberAndCreatedAt(
      accountNumber: $accountNumber
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        commission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        createdAt
        updatedAt
        accountInformationUserOrdersId
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const userOrderByAccountNumberAndStatus = /* GraphQL */ `
  query UserOrderByAccountNumberAndStatus(
    $accountNumber: String!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userOrderByAccountNumberAndStatus(
      accountNumber: $accountNumber
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNumber
        owner
        subAccountNumber
        cancel
        cancelReplace
        commission
        symbol
        side
        brokerSkipChecks
        brokerOverride
        brokerId
        quantity
        limitPrice
        stopPrice
        stockValue
        originalOrderId
        strategy
        avgPx
        orderType
        timeInForce
        instruction
        userOrderLegs {
          legType
          side
          quantity
          expiration
          strike
          openClose
          bid
          ask
          sharesPerContract
          avgPx
          __typename
        }
        cashSecured
        cashSecuredAmount
        message
        submitStatus
        status
        executionReports {
          items {
            id
            owner
            accountInformationId
            subAccountNumber
            orderID
            executionIncrementId
            secondaryOrderID
            clOrdID
            origClOrdID
            clientID
            execBroker
            listID
            execID
            execTransType
            execRefID
            execType
            ordStatus
            ordRejReason
            execRestatementReason
            account
            settlmntTyp
            futSettDate
            symbol
            symbolSfx
            securityID
            iDSource
            securityType
            maturityMonthYear
            maturityDay
            putOrCall
            strikePrice
            optAttribute
            contractMultiplier
            couponRate
            securityExchange
            issuer
            encodedIssuerLen
            encodedIssuer
            securityDesc
            encodedSecurityDescLen
            encodedSecurityDesc
            side
            orderQty
            cashOrderQty
            ordType
            price
            stopPx
            pegDifference
            discretionInst
            discretionOffset
            currency
            complianceID
            solicitedFlag
            timeInForce
            effectiveTime
            expireDate
            expireTime
            execInst
            rule80A
            lastShares
            lastPx
            lastSpotRate
            lastForwardPoints
            lastMkt
            tradingSessionID
            lastCapacity
            leavesQty
            cumQty
            avgPx
            dayOrderQty
            dayCumQty
            dayAvgPx
            gTBookingInst
            tradeDate
            transactTime
            reportToExch
            commission
            commType
            grossTradeAmt
            settlCurrAmt
            settlCurrency
            settlCurrFxRate
            settlCurrFxRateCalc
            handlInst
            minQty
            maxFloor
            openClose
            maxShow
            text
            encodedTextLen
            encodedText
            futSettDate2
            orderQty2
            clearingFirm
            clearingAccount
            multiLegReportingType
            legRefId
            uploadedToBackoffice
            fixMessage
            processedAt
            createdDate
            createdAt
            updatedAt
            userOrderExecutionReportsId
            groupOrderExecutionReportsId
            __typename
          }
          nextToken
          __typename
        }
        cryptoOrder
        groupUploadOrderId
        createdAt
        updatedAt
        accountInformationUserOrdersId
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getUserSettings = /* GraphQL */ `
  {
    userSettings {
      nodes {
        id
			  owner
        key
			  category
			  subCategory
			  settings
      }
    }
  }
`;

export const getAccountActivities = /* GraphQL */ `
  query SearchAccountActivity(
    $fromProcessDate: Date,
    $toProcessDate: Date,
    $securityType: String, 
    $source: String, 
    $symbol: String,
    $accountNumber: String,
    $first: Int,
    $offset: Int,
  ) {
    searchAccountActivity(
      fromProcessDate: $fromProcessDate,
      toProcessDate: $toProcessDate,
      securityType: $securityType,
      source: $source,
      symbol: $symbol
      accountNumber: $accountNumber
      first: $first,
      offset: $offset,
    ) {
      nodes {
        owner
        accountNumber
        securityType
        securityTypeNote
        processDate
        action
        description
        quantity
        feesConfirm
        amount
        details
        dataSource
        debugNote
        historyDate
        price
        symbol
        source
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;

export const getLookupItems = /* GraphQL */ `
{
  lookupItems {
    nodes {
      lookupKey
      lookupValue
      lookupGroupCode
    }
  }
}
`;

export const getPositionsByAccountNumber = /* GraphQL */ `
query GetPositions(
$accountNumber: String!
 ) {
  getPositionsByAccountNumber(
    targetAccountNumber: $accountNumber
  ) {
    nodes{
      id
      pairId
      accountNumber
      owner
      underlying
      isCryptoPosition
      quantity
      legquantity
      pricePaid
      createdAt
      updatedAt
      accountInformationPositionsId
      positiontype
      strategy
      strike
      expiration
		}
  }
}
`;

export const listDraftUserProfiles = /* GraphQL */ `
  query ListDraftUserProfiles(
    $id: ID
    $filter: ModelDraftUserProfileFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDraftUserProfiles(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        cognitoId
        owner
        userAccountType
        memberStatus
        memberDate
        lastChargeDate
        contactDetails {
          givenName
          familyName
          phone {
            phoneType
            phoneNumber
            __typename
          }
          email
          __typename
        }
        homeAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        email
        familyName
        phoneNumber
        employment {
          employmentStatus
          employerName
          position
          yearsEmployed
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        mailingAddress {
          streets
          city
          state
          postal
          country
          __typename
        }
        trustedContact {
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          address {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        investmentProfile {
          riskStandardOptions
          uncoveredOptionWriters
          investmentExperience
          riskTolerance
          investmentObjective
          minTotalNetWorthUSD
          minAnnualIncomeUSD
          minLiquidNetWorthUSD
          maxTotalNetWorthUSD
          maxAnnualIncomeUSD
          maxLiquidNetWorthUSD
          timeHorizon
          liquidityNeeds
          stockTradesPerYear
          optionsTradesPerYear
          commonditiesTradesPerYear
          corporateBondsTradesPerYear
          municipalBondsTradesPerYear
          governmentBondsTradesPerYear
          fundsTradesPerYear
          marginAccountTradesPerYear
          optionDisclosureDeliveryDate
          priorInvestmentExperiences {
            firmName
            numberOfYears
            stillOpen
            estimatedValueUSD
            __typename
          }
          __typename
        }
        profilePicture {
          id
          owner
          profilePicture
          createdAt
          updatedAt
          __typename
        }
        dateOfBirth
        socialSecurityNumber
        citizenshipCountry
        catAccountholderType
        customerType
        accountType
        politicallyExposed {
          politicalOrganization
          immediateFamily
          __typename
        }
        controlPersonSymbols
        affiliated {
          firmName
          affiliatedApproval
          docS3Key
          __typename
        }
        customerAccountAgreement
        privacyPolicy
        accountNumbers
        status
        visaType
        visaExpirationDate
        permanentResident
        isCorrespondentEmployee
        custodianType
        custodialState
        entityAccountInformation {
          entityName
          entityTaxId
          stateOfOrigin
          mailingPreference
          isPabAccount
          isUSEntity
          issuerDirectCommunicationCode
          isExemptLegalCustomer
          exemption
          legalEntityIdentifier
          entityOfficers {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            __typename
          }
          beneficialOwners {
            familyName
            givenName
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            __typename
          }
          accountNature
          __typename
        }
        authorizedSignerTitle
        isUsCitizen
        isForeignBank
        isForeignShellBank
        foreignBankUSAgent
        isMaintainedForForeignFinancialInstitution
        offersServicesToForeignShellBank
        dividendReinvestment
        trusteeTaxId
        trusteeIsUsCitizen
        entityTrust {
          trustName
          isPabAccount
          dateOfTrustCreation
          trustTaxId
          legalAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          __typename
        }
        oatsAccountholderType
        issuerDirectCommunicationCode
        entityCertOfTrust {
          trustTitle
          trustEffectiveDate
          trustSitusState
          trustRevocability
          trustees {
            contactDetails {
              givenName
              familyName
              phone {
                phoneType
                phoneNumber
                __typename
              }
              email
              __typename
            }
            dateOfBirth
            address {
              streets
              city
              state
              postal
              country
              __typename
            }
            socialSecurityNumber
            identificationNumber
            identification {
              number
              documentType
              issuedBy
              issueDate
              snapId
              expirationDate
              s3Uri
              __typename
            }
            __typename
          }
          trustDocumentSnapId
          trustDocumentS3Uri
          trustAgreementAllowsOptions
          trustAgreementAllowsMarginsAndShortPositions
          __typename
        }
        membersAndManagers {
          legalName
          organizationalRole
          isManager
          __typename
        }
        resolutionAdoptionDate
        authorizedSignerName
        secretaryName
        applicants {
          citizenshipCountry
          birthCountry
          dateOfBirth
          contactDetails {
            givenName
            familyName
            phone {
              phoneType
              phoneNumber
              __typename
            }
            email
            __typename
          }
          homeAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          mailingAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          employment {
            employmentStatus
            employerName
            position
            yearsEmployed
            businessAddress {
              streets
              city
              state
              postal
              country
              __typename
            }
            __typename
          }
          foreignTaxIdCountry
          foreignTaxIdNumber
          socialSecurityNumber
          visaType
          visaExpirationDate
          permanentResident
          identificationType
          identificationNumber
          countryOfIssue
          identificationIssueDate
          identificationExpirationDate
          identificationS3Uri
          identificationSnapId
          __typename
        }
        communityPropertyState
        jointType
        jointTenantsInCommonParticipants {
          name
          estatePercent
          __typename
        }
        birthCountry
        foreignTaxIdCountry
        foreignTaxIdNumber
        identificationType
        identificationNumber
        countryOfIssue
        identificationIssueDate
        identificationExpirationDate
        identificationS3Uri
        identificationSnapId
        typeIra
        brokerageFirmAuthorization
        decedentName
        simpleIraPlanName
        iraBeneficialOwners {
          givenName
          familyName
          beneficiaryType
          sharePercent
          relationship
          socialSecurityNumber
          __typename
        }
        adoptingEmployer {
          name
          businessAddress {
            streets
            city
            state
            postal
            country
            __typename
          }
          phoneNumber
          taxId
          __typename
        }
        planInfo {
          name
          date
          administrator
          __typename
        }
        participantType
        articlesOfIncorporationOrOperatingAgreementSnapId
        articlesOfIncorporationSnapId
        articlesOfIncorporationOrOperatingAgreementS3uri
        articlesOfIncorporationS3uri
        isFinishedOnboarding
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;